<template>
  <v-select
    v-bind="$attrs"
    item-text="text"
    item-value="value"
    :items="items"
    :value="value"
    @change="$emit('change', $event)"
  />
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: [Number, String],
      default: '',
    },
  },
  computed: {
    items() {
      return [
        { text: this.$t('common.yes'), value: 1 },
        { text: this.$t('common.no'), value: 0 },
      ];
    },
  },
};
</script>

<style></style>
